export default __webpack_public_path__ + "static/media/arrow_left.7b8a7b80.svg";